/**
 * True when the app is on the tunnel kiosk route (`/tunnel`, not `/tunnel/login`).
 * Used to skip shop-staff-only APIs (e.g. `user/payment-modes`) that require `userData` JWT.
 */
export function isTunnelAppContext(url?: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const path =
    (url ?? window.location.pathname).split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
  return path === '/tunnel' || (path.startsWith('/tunnel/') && !path.startsWith('/tunnel/login'));
}
